import { merge } from "@intelligems/ig-utils";

const createNestedObject = (path: string, value: any): any => {
  const keys = path.split(".");
  return keys.reduceRight((acc, key) => ({ [key]: acc }), value);
};

export const updateStyleOverrides = (
  currentStyleOverrides: any = {},
  field: string,
  value: any
) => {
  const nestedUpdate = createNestedObject(field, value);
  return merge(currentStyleOverrides, nestedUpdate);
};

// Helper function to update draft state using dot notation
export const updateDraftStyles = (draft: any, field: string, value: any) => {
  const keys = field.split(".");
  let current = draft.styles;

  // Navigate to the parent object
  for (let i = 0; i < keys.length - 1; i++) {
    if (!current[keys[i]]) {
      current[keys[i]] = {};
    }
    current = current[keys[i]];
  }

  // Set the final value
  current[keys[keys.length - 1]] = value;
};
